import { forwardRef } from 'react';
import { NumericFormat } from 'react-number-format';

const NumberFormatInputUI = forwardRef(function NumberFormatInputUI(props, ref) {
  const { onChange, name, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      thousandSeparator=" "
      decimalSeparator=","
      valueIsNumericString
      onValueChange={(values) => {
        onChange({
          target: {
            name,
            value: values.floatValue ?? null,
          },
        });
      }}
    />
  );
});

export default NumberFormatInputUI;
